import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { AppConfig } from "./config";
import { DefaultDataService } from "./defaultdata.service";

@Injectable({
  providedIn: "root"
})
export class DataService {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfig,
    private router: Router,
    private defaultDataService: DefaultDataService
  ) {
    this.defaultDataService.setDataService(this);
  }

  //Query Service**
  // getAllOrganizations(): Observable<any> {
  //   return this.httpClient.get(this.appConfig.config.ipaddress + ':50000/api/v1/turbo/r/organization/all')
  // }
  getAllOrganizations(): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/organization/all"
    );

    return this.httpClient.get(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/organization/all",
      { headers, params }
    );
  }

  // getAllProducts(): Observable<any> {
  //   return this.httpClient.get(this.appConfig.config.ipaddress + ':50000/api/v1/turbo/r/organization/products')
  // }

  getAllProducts(): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/organization/products"
    );

    // return this.httpClient.get(this.appConfig.config.ipaddress + ':6001/api/v1/turbo/r/organization/products')
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/organization/products",
      { headers, params }
    );
  }
  //application api
  getApplications(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/application";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/application/all",
      data
    );
  }

  getApplicationById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/application";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/application/id",
      data
    );
  }

  //metaobject api
  getMetaObjects(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metaobject/all",
      data
    );
  }

  getMetaobjectById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metaobject/id",
      data
    );
  }

  getActiveObjectsByType(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaobject/active",
      data
    );
  }

  getActiveMatchingRulesByObject(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/matchingrule";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/matchingrule/object",
      data
    );
  }

  //recordtype on object
  getRecordTypes(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaobject/recordtypes",
      data
    );
  }

  getMetaProfileLayouts(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaobject/profile/metaprofilelayout",
      data
    );
  }

  getRecordTypeById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaobject/recordtype/id",
      data
    );
  }

  getRecordTypePicklistValueById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaobject/recordtype/recordtypepicklistvalue/id",
      data
    );
  }

  getRecordTypeLayouts(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaobject/recordtype/recordtypelayout",
      data
    );
  }

  //user permission api
  getAppSettingsByName(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/userpermission";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/userpermission/appsettings/app",
      data
    );
  }

  getActiveProfileByUserLicense(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/userpermission";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/userpermission/profile/active/license",
      data
    );
  }

  checkCustomViewCreatePermission(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/userpermission";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/userpermission/profile/customview/new",
      data
    );
  }

  checkCustomViewEditPermission(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/userpermission";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/userpermission/profile/customview/edit",
      data
    );
  }

  getQueuesForSelection(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/userpermission";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/userpermission/queues/selection",
      data
    );
  }

  //login api
  login(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/login";

    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/login",
      data,
      { headers }
    );
  }

  //metafield api
  getMetaFields(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metafield/all",
      data
    );
  }

  getMetaFieldHistory(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metafield/metafieldhistory",
      data
    );
  }

  getMetafieldById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metafield/id",
      data
    );
  }

  getMetaProfileFields(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metafield/profile/fieldid",
      data
    );
  }

  getAllMetaProfileFieldsByObject(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metafield/profile/metaobjectid",
      data
    );
  }

  getMetaFieldsForSelection(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metafield/selection",
      data
    );
  }

  getOrgLanguage(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/metafield"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/metafield/orglanguage/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getTranslationLabelById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metafield/metafieldlabeltranslation",
      data
    );
  }

  getObjectTranslationLabelById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaobject/metaobjectlabeltranslation",
      data
    );
  }

  getApplicationTranslationLabelById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/application";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/application/metaapplicationlabeltranslation",
      data
    );
  }

  getButtonTranslationLabelById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metabutton";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metabutton/metabuttonlabeltranslation",
      data
    );
  }

  getLayoutTranslationLabelById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/metalayoutlabeltranslation",
      data
    );
  }

  //metabutton api
  getMetaButtons(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metabutton";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metabutton/all",
      data
    );
  }
  getMetaButtonsLayout(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metabutton";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metabutton/layout",
      data
    );
  }
  getMetabuttonById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metabutton";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metabutton/id",
      data
    );
  }

  getLayouts(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/layouts",
      data
    );
  }

  getCustomViews(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/customviews",
      data
    );
  }

  getRefineLayouts(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/refinelayouts",
      data
    );
  }

  getMetalayoutByName(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metalayout/name",
      data
    );
  }

  getLookupFields(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/metafield/lookup",
      data
    );
  }

  getLookupFieldsAllVisibility(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/metafield/lookup/all/visibility",
      data
    );
  }

  getObjectLookupFields(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/object/lookup",
      data
    );
  }

  getMetaRelatedlayout(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metalayout/metarelatedlayout/id",
      data
    );
  }

  getLookup(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/reporttype";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/reporttype/internal/lookup",
      data
    );
  }

  getMetaGlobalAction(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaglobalaction";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metaglobalaction",
      data
    );
  }

  getMetaGlobalActionById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metaglobalaction";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metaglobalaction/id",
      data
    );
  }

  getAllSearchLayout(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metasearchlayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/metasearchlayout",
      data
    );
  }

  getAllSearchLayoutById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metasearchlayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/metasearchlayout/id",
      data
    );
  }

  getProcessFields(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/process";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/process/processfield/objectid",
      data
    );
  }

  getActiveProcess(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/process";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/process",
      data
    );
  }

  getProcessById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/process";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/process/id",
      data
    );
  }

  getReportTypes(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/reporttype"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/reporttype/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getReportTypeById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/reporttype";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/reporttype/id",
      data
    );
  }

  getReportTypeSectionById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/reporttype";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/reporttype/reporttypesection/id",
      data
    );
  }

  getReportTypeColumnById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/reporttype";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/reporttype/reporttypecolumn/id",
      data
    );
  }

  getReports(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/report"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/report/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getReportById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/report";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/report/id",
      data
    );
  }

  getFolders(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/folder"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/folder/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getFolderById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/folder";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/folder/id",
      data
    );
  }

  getConvertSettings(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/convertsetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/convertsetting/all/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getConvertSettingsById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/convertsetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/convertsetting/id",
      data
    );
  }

  getDashboard(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/dashboard"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/dashboard/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getDashboardById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/dashboard";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/dashboard/id",
      data
    );
  }

  getValidationRule(
    organizationid: any,
    metaobjectid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/validationrule"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/validationrule/${organizationid}/${metaobjectid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getValidationRuleById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/validationrule";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/r/validationrule/id",
      data
    );
  }

  getMatchingRule(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/matchingrule"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/matchingrule/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getMatchingRuleById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/matchingrule";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/matchingrule/id",
      data
    );
  }

  getDuplicateRule(
    organizationid: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/duplicaterule"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/duplicaterule/${organizationid}/${domain}/${subdomain}`,
      { params }
    );
  }

  getDuplicateRuleById(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/duplicaterule";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/r/duplicaterule/id",
      data
    );
  }

  getAllMessageCategory(domain: any, subdomain: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/crudmessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/crudmessage/messagecategory/${domain}/${subdomain}`,
      { params }
    );
  }

  getCrudMessage(
    domain: any,
    subdomain: any,
    organizationid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/crudmessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/crudmessage/all/${domain}/${subdomain}/${organizationid}`,
      { params }
    );
  }
  getCrudMessageById(domain: any, subdomain: any, id: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/crudmessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/crudmessage/id/${domain}/${subdomain}/${id}`,
      { params }
    );
  }

  getErrorMessageCategory(domain: any, subdomain: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/errormessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/errormessage/messagecategory/${domain}/${subdomain}`,
      { params }
    );
  }

  getAllErrorCode(
    domain: any,
    subdomain: any,
    organizationid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/errormessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/errormessage/errorcode/${domain}/${subdomain}/${organizationid}`,
      { params }
    );
  }

  getErrorMessage(
    domain: any,
    subdomain: any,
    organizationid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/errormessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/errormessage/all/${domain}/${subdomain}/${organizationid}`,
      { params }
    );
  }

  getErrorMessageById(domain: any, subdomain: any, id: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/errormessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/errormessage/id/${domain}/${subdomain}/${id}`,
      { params }
    );
  }

  getAllSectionRoot(
    domain: any,
    subdomain: any,
    organizationid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/modulesetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/modulesetting/sectionroot/${domain}/${subdomain}/${organizationid}`,
      { params }
    );
  }

  getSectionRootById(
    domain: any,
    subdomain: any,
    organizationid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/modulesetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/modulesetting/sectionroot/id/${domain}/${subdomain}/${organizationid}/${id}`,
      { params }
    );
  }

  getAllModuleSetting(
    domain: any,
    subdomain: any,
    organizationid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/modulesetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/modulesetting/all/${domain}/${subdomain}/${organizationid}`,
      { params }
    );
  }

  getModuleSettingById(
    domain: any,
    subdomain: any,
    organizationid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/modulesetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/modulesetting/id/${domain}/${subdomain}/${organizationid}/${id}`,
      { params }
    );
  }

  getAllDomainSetting(
    domain: any,
    subdomain: any,
    organizationid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/domainsetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/domainsetting/all/${domain}/${subdomain}/${organizationid}`,
      { params }
    );
  }

  getDomainsettingById(
    domain: any,
    subdomain: any,
    organizationid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/domainsetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/domainsetting/id/${domain}/${subdomain}/${organizationid}/${id}`,
      { params }
    );
  }

  getAllDomainSettingSection(
    domain: any,
    subdomain: any,
    organizationid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/domainsetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/domainsetting/section/all/${domain}/${subdomain}/${organizationid}/${id}`,
      { params }
    );
  }

  getDomainsettingSectionById(
    domain: any,
    subdomain: any,
    organizationid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/domainsetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/domainsetting/section/id/${domain}/${subdomain}/${organizationid}/${id}`,
      { params }
    );
  }

  getAllDomainFeilds(
    domain: any,
    subdomain: any,
    organizationid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/domainsetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/domainsetting/section/fields/all/${domain}/${subdomain}/${organizationid}/${id}`,
      { params }
    );
  }

  getDomainFieldsById(
    domain: any,
    subdomain: any,
    organizationid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/domainsetting"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/domainsetting/section/fields/id/${domain}/${subdomain}/${organizationid}/${id}`,
      { params }
    );
  }

  getAllFieldDependency(
    domain: any,
    subdomain: any,
    organizationid: any,
    metaobjectid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/metafielddependency"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/metafielddependency/all/${domain}/${subdomain}/${organizationid}/${metaobjectid}`,
      { params }
    );
  }

  getFieldDependencyById(
    domain: any,
    subdomain: any,
    organizationid: any,
    metaobjectid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/metafielddependency"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/metafielddependency/id/${domain}/${subdomain}/${organizationid}/${metaobjectid}/${id}`,
      { params }
    );
  }

  ///////**************** */
  //Create Service
  //Application
  upsertApplication(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/application";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/application/upsert",
      data
    );
  }

  upsertNode(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/r/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":41000/api/v1/node/upsert",
      data
    );
  }
  //Metaobject
  upsertMetaobject(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metaobject/upsert",
      data
    );
  }

  /*
  upsertMetaobject(data): Observable<any> {
    var response;
    console.log("beforecalling createOrUpdateMetaobject");

    response = this.createOrUpdateMetaobject(data);

    console.log("aftercalling createOrUpdateMetaobject");

    console.log(response);

    //add default layouts if the mode is new and objecttype is domain
    var mode = data.data.metaobject.mode;
    console.log(mode);
    var objectType = data.data.metaobject.objecttype;
    if(mode.toLowerCase().trim() == "new" && objectType.toLowerCase().trim() == "domain"){

      this.defaultDataService.createDefaultRecords(data).subscribe(
        res => {
          //alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            response = res;
          }
          else {
            console.log("error");
            response = res;
          }
        },
        err => {
          console.log("Error***:", err);
          response.success =0;
          response.message = err.message;
        }
      );

    }

    return response;

  }


  async createOrUpdateMetaobject(data){
    return await this.httpClient.post(this.appConfig.config.ipaddress + ':42000/api/v1/metaobject/upsert', data);
  }
  */
  //Recordtype
  upsertRecordType(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metaobject/recordtype/upsert",
      data
    );
  }

  upsertRecordTypeLayout(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metaobject/recordtype/recordtypelayout/upsert",
      data
    );
  }

  upsertRecordTypePicklistValue(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metaobject/recordtype/recordtypepicklistvalue/upsert",
      data
    );
  }

  upsertReportType(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/reporttype";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/reporttype/upsert",
      data
    );
  }

  upsertFolder(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/folder";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/c/folder/upsert",
      data
    );
  }

  upsertReport(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/report";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/c/report/upsert",
      data
    );
  }

  upsertConvertSetting(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/convertsetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/convertsetting/upsert",
      data
    );
  }

  upsertConvertionObjectField(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/convertsetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/convertsetting/convertionobjectfield/upsert",
      data
    );
  }

  //Metafield
  upsertMetafield(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/c/metafield/upsert",
      data
    );
  }

  upsertMetafieldHistory(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metafield";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metafield/metafieldhistory/upsert",
      data
    );
  }

  //Metabutton
  upsertMetabutton(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metabutton";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metabutton/upsert",
      data
    );
  }

  //Metabutton
  upsertMetalayout(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metalayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metalayout/upsert",
      data
    );
  }

  getMetaButtonsForSelection() {}

  layoutData(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metalayout";
    // return this.httpClient.post(this.appConfig.config.ipaddress + ':47000/api/v1/metalayout/new', data);
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metalayout/upsert",
      data
    );
  }

  upsertMetaglobalaction(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metaglobalaction";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metaglobalaction/upsert",
      data
    );
  }

  upsertMetaSearchlayout(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metasearchlayout";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metasearchlayout/upsert",
      data
    );
  }

  upsertProcess(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/process";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/c/process/upsert",
      data
    );
  }

  upsertDashboard(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/dashboard";
    return this.httpClient.post(
      this.appConfig.config.ipaddress + ":6001/api/v1/turbo/c/dashboard/upsert",
      data
    );
  }

  upsertValidationRule(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/validationrule";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/validationrule/upsert",
      data
    );
  }

  upsertMatchingRule(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/matchingrule";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/matchingrule/upsert",
      data
    );
  }

  upsertDuplicateRule(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/duplicaterule";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/duplicaterule/upsert",
      data
    );
  }

  upsertCrudMessage(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/crudmessage";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/crudmessage/upsert",
      data
    );
  }

  upsertErrorMessage(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/errormessage";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/errormessage/upsert",
      data
    );
  }

  upsertSectionRoot(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/modulesetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/modulesetting/sectionroot/upsert",
      data
    );
  }

  upsertModuleSetting(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/modulesetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/modulesetting/upsert",
      data
    );
  }

  upsertDomainSetting(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/domainsetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/domainsetting/upsert",
      data
    );
  }

  upsertDomainSettingSection(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/domainsetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/domainsetting/section/upsert",
      data
    );
  }
  upsertDomainSettingFields(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/domainsetting";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/domainsetting/section/fields/upsert",
      data
    );
  }

  upsertMetaFieldDependency(data): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metafielddependency";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/metafielddependency/upsert",
      data
    );
  }

  upsertErrorCode(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/errormessage";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        ":6001/api/v1/turbo/c/errormessage/upsert/code",
      data
    );
  }

  getErrorcodeById(domain: any, subdomain: any, id: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/r/errormessage"
    );
    return this.httpClient.get(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/r/errormessage/errorcode/id/${domain}/${subdomain}/${id}`,
      { params }
    );
  }

  // layoutDataEdit(data:any):Observable<any> {
  //   return this.httpClient.post(this.appConfig.config.ipaddress + ':47000/api/v1/metalayout/upsert', data)

  // }

  // DeleteService
  // deleteMetaglobalaction(organizationid:any, id: any): Observable<any> {
  //   return this.httpClient.delete(this.appConfig.config.ipaddress + `:33000/api/v1/metaglobalaction/delete/${organizationid}/${id}`)
  // }

  deleteMetaglobalaction(
    organizationid: any,
    domain: any,
    subdomain: any,
    id: any,
    metaobjectid: any,
    metalayoutid: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/metaglobalaction"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/metaglobalaction/delete/${organizationid}/${domain}/${subdomain}/${id}/${metaobjectid}/${metalayoutid}`,
      { params }
    );
  }

  deleteMetafield(
    organizationid: any,
    domain: any,
    subdomain: any,
    metaobjectid: any,
    id: any,
    profilename: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/metafield"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/metafield/delete/${organizationid}/${domain}/${subdomain}/${metaobjectid}/${id}/${profilename}`,
      { params }
    );
  }

  deleteMetalayout(
    organizationid: any,
    domain: any,
    subdomain: any,
    metaobjectid: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/metalayout"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/metalayout/delete/${organizationid}/${domain}/${subdomain}/${metaobjectid}/${id}`,
      { params }
    );
  }

  deleteProcess(
    organizationid: any,
    domain,
    subdomain,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/process"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/process/delete/${organizationid}/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteReportType(
    organizationid: any,
    domain: any,
    subdomain: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/reporttype"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/reporttype/delete/${organizationid}/${domain}/${subdomain}/${id}`,
      { params }
    );
  }

  deleteReport(
    organizationid: any,
    domain: any,
    subdomain: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/report"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/report/delete/${organizationid}/${domain}/${subdomain}/${id}`,
      { params }
    );
  }
  deleteDashboard(
    organizationid: any,
    domain: any,
    subdomain: any,
    id: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/dashboard"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/dashboard/delete/${organizationid}/${domain}/${subdomain}/${id}`,
      { params }
    );
  }

  deleteValidationRule(
    organizationid: any,
    id: any,
    objectname: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/validationrule"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/validationrule/delete/${organizationid}/${id}/${objectname}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteMatchingRule(
    organizationid: any,
    id: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/matchingrule"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/matchingrule/delete/${organizationid}/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteDuplicateRule(
    organizationid: any,
    id: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/duplicaterule"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/duplicaterule/delete/${organizationid}/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteCrudMessage(
    id: any,
    type: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/crudmessage"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/crudmessage/delete/${id}/${type}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteDomainSetting(
    id: any,
    type: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/domainsetting"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/domainsetting/delete/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteDomainSettingSection(
    id: any,
    type: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/domainsetting"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/domainsetting/section/delete/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteDomainSettingFields(
    id: any,
    type: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/domainsetting"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/domainsetting/section/fields/delete/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteErrorMessage(
    id: any,
    type: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/errormessage"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/errormessage/delete/${id}/${type}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteErrorCode(id: any, domain: any, subdomain: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/errormessage"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/errormessage/errorcode/delete/${id}/${domain}/${subdomain}`,
      { params }
    );
  }
  deleteSectionRoot(
    organizationid: any,
    id: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/modulesetting"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/modulesetting/sectionroot/delete/${organizationid}/${id}/${domain}/${subdomain}`,
      { params }
    );
  }
  deleteMenuSetting(
    organizationid: any,
    id: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/modulesetting"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/modulesetting/menusetting/delete/${organizationid}/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  deleteMetafieldDependency(
    organizationid: any,
    id: any,
    domain: any,
    subdomain: any
  ): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    const params = new HttpParams().set(
      "relative_url",
      "api/v1/turbo/c/metafielddependency"
    );
    return this.httpClient.delete(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/metafielddependency/delete/${organizationid}/${id}/${domain}/${subdomain}`,
      { params }
    );
  }

  //Kafka Publish

  metaobjectPublish(data: any): Observable<any> {
    return this.httpClient.post(
      this.appConfig.kafkaConfig.ipaddress + `:8443/api/v1/erp/message/publish`,
      data
    );
  }

  messagePublish(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/metaobject/publish/message`,
      data
    );
  }

  outboxeventPublish(data: any): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "turoboauthkey");
    data.relative_url = "api/v1/turbo/c/metaobject";
    return this.httpClient.post(
      this.appConfig.config.ipaddress +
        `:6001/api/v1/turbo/c/metaobject/publish/outboxevents`,
      data
    );
  }
}
